export const getContactInfo = (saleType, tsmDetails, stateCode) => {
    if (!saleType || !tsmDetails) return [];

  const phone1 = { label: tsmDetails.ContactPhone1Label, value: tsmDetails.ContactPhone1Value };
  const phone2 = { label: tsmDetails.ContactPhone2Label, value: tsmDetails.ContactPhone2Value };
  const phone3 = { label: tsmDetails.ContactPhone3Label, value: tsmDetails.ContactPhone3Value };
  const phone4 = { label: tsmDetails.ContactPhone4Label, value: tsmDetails.ContactPhone4Value };

  const auditorCard = {
    role: tsmDetails.auditor?.name ? "Auditor" : phone4?.label,
    name: tsmDetails.auditor?.name,
    phone: tsmDetails.auditor?.phone || phone4?.value,
  };

  const treasurerCard = {
    role: tsmDetails.treasurer?.name ? "Treasurer" : phone2.label,
    name: tsmDetails.treasurer?.name,
    phone: tsmDetails.treasurer?.phone || phone2.value,
  };

  switch (saleType) {
    case "A": // Tax Sales
      if (stateCode === "IN") {
        return [
          phone1.value && { role: phone1.label, phone: phone1.value },
          auditorCard,
          treasurerCard,
        ].filter(c => c && c.phone);
      }
      if (stateCode === "CO" || stateCode === "IA") {
        return [
          phone1.value && { role: phone1.label, phone: phone1.value },
          treasurerCard,
        ].filter(c => c && c.phone);
      }
      if (stateCode === "LA") {
        return [
          phone1.value && { role: phone1.label, phone: phone1.value },
          phone3.value && { role: phone3.label, phone: phone3.value },
        ].filter(Boolean);
      }
      if (stateCode === "AL" || stateCode === "TN") {
        return [
          phone1.value && { role: phone1.label, phone: phone1.value },
          phone2.value && { role: phone2.label, phone: phone2.value },
        ].filter(Boolean);
      }
      return [auditorCard, treasurerCard].filter(c => c.phone);

    case "C": // Certificate Sales
      if (stateCode === "IN") {
        return [
          phone1.value && { role: phone1.label, phone: phone1.value },
          auditorCard,
          treasurerCard,
        ].filter(c => c && c.phone);
      }
      if (stateCode === "FL") {
        return [
          phone1.value && { role: phone1.label, phone: phone1.value },
          treasurerCard,
        ].filter(c => c && c.phone);
      }
      return [auditorCard, treasurerCard].filter(c => c.phone);

      case "F": // Foreclosure Sales
        if (stateCode === "IN") {
          return [
            phone3.value && { role: phone3.label, phone: phone3.value },
          ].filter(Boolean);
        }
        if (stateCode === "LA" || stateCode === "MI" || stateCode === "CO") {
          return [
            tsmDetails.ForeclosureGeneralPhone && { role: "Foreclosure General Phone", phone: tsmDetails.ForeclosureGeneralPhone },
          ].filter(Boolean);
        }
        return [];

    case "D": // Deed Sales
      if (stateCode === "IN") {
        return [
          phone1.value && { role: phone1.label, phone: phone1.value },
          auditorCard,
          treasurerCard,
        ].filter(c => c && c.phone);
      }
      if (stateCode === "CO") {
        return [
          phone3.value && { role: phone3.label, phone: phone3.value },
        ].filter(Boolean);
      }
      if (stateCode === "MI") {
        return [
          phone1.value && { role: phone1.label, phone: phone1.value },
          phone3.value && { role: phone3.label, phone: phone3.value },
        ].filter(Boolean);
      }
      return [];

    default:
      return [];
  }
};